import { render, staticRenderFns } from "./url-modal.vue?vue&type=template&id=21948f5b&scoped=true&"
import script from "./url-modal.vue?vue&type=script&lang=ts&"
export * from "./url-modal.vue?vue&type=script&lang=ts&"
import style0 from "./url-modal.vue?vue&type=style&index=0&id=21948f5b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21948f5b",
  null
  
)

export default component.exports